import { supabase } from "@/lib/supabaseClient";

const BASE = process.env.REACT_APP_BACKEND_URL;

export async function apiFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  const res = await fetch(`${BASE}/api${path}`, { ...options, headers });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; }
  catch { data = { detail: text || "Unexpected server response." }; }
  if (!res.ok) {
    const msg = typeof data?.detail === "string" ? data.detail : (data?.detail?.message || `Request failed (${res.status})`);
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Authenticated file download (zip/csv). Streams the response to a blob and
// triggers a browser download, preserving the Authorization header.
export async function downloadFile(path, { method = "GET", fallbackName = "download" } = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = {};
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  const res = await fetch(`${BASE}/api${path}`, { method, headers });
  if (!res.ok) {
    let detail = `Download failed (${res.status})`;
    try { detail = (await res.json())?.detail || detail; } catch { /* ignore */ }
    throw new Error(detail);
  }
  const disp = res.headers.get("Content-Disposition") || "";
  const match = disp.match(/filename="?([^"]+)"?/);
  const name = match ? match[1] : fallbackName;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
  return name;
}
export async function uploadFile(path, file, { method = "POST", fields = {} } = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const form = new FormData();
  form.append("file", file);
  Object.entries(fields || {}).forEach(([k, v]) => form.append(k, v));
  const headers = {};
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  const res = await fetch(`${BASE}/api${path}`, { method, body: form, headers });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; }
  catch { data = { detail: text || "Unexpected server response." }; }
  if (!res.ok) throw new Error(data?.detail || `Upload failed (${res.status})`);
  return data;
}
